import { usePartialDate } from "../../../hooks/usePartialDate";
import { DATE_PRECISION_LABELS, MONTH_NAMES, validPartialDate, type DatePrecision } from "../../../utils/partialDate";

interface Props {
  id: string; value: string | null; invalid: boolean; required: boolean;
  describedBy?: string; onChange: (value: string | null) => void;
}
export function PartialDateInput({ id, value, invalid, required, describedBy, onChange }: Props) {
  const date = usePartialDate(value, onChange);
  const incomplete = !!value && !validPartialDate(value);
  const helpId = `${id}-precision-help`;
  const attributes = { "aria-invalid": invalid || incomplete, "aria-describedby": [describedBy, helpId].filter(Boolean).join(" ") };
  return <div className="flex flex-col gap-2">
    <div className="flex flex-col gap-2">
      <select id={id} className="cr-input" aria-label="Date precision" value={date.precision}
        onChange={event => date.selectPrecision(event.target.value as DatePrecision)}>
        {Object.entries(DATE_PRECISION_LABELS).map(([key, label]) => <option key={key} value={key}>{label}</option>)}
      </select>
      <div className="grid grid-cols-3 gap-2">
      <input {...attributes} className="cr-input" aria-label="Date year" aria-required={required}
        inputMode="numeric" maxLength={4} placeholder="YYYY" value={date.year}
        onChange={event => date.changePart(0, event.target.value)} />
      {date.precision !== "year" && <select {...attributes} className="cr-input" aria-label="Date month" value={date.month}
        onChange={event => date.changePart(1, event.target.value)}>
        <option value="">Month</option>
        {MONTH_NAMES.map((month, index) => <option key={month} value={String(index + 1).padStart(2, "0")}>{month}</option>)}
      </select>}
      {date.precision === "day" && <input {...attributes} className="cr-input" aria-label="Date day"
        inputMode="numeric" maxLength={2} placeholder="DD" value={date.day}
        onChange={event => date.changePart(2, event.target.value)}
        onBlur={() => { if (/^[1-9]$/.test(date.day)) date.changePart(2, date.day.padStart(2, "0")); }} />}
      </div>
      {value && <button type="button" className="self-start text-sm text-muted-foreground" onClick={date.clear}>Clear date</button>}
    </div>
    <span id={helpId} className="text-xs text-muted-foreground">{incomplete
      ? "Complete the selected date parts, or choose a lower precision."
      : "Enter only the date parts reported in the source."}</span>
  </div>;
}
